import { render, staticRenderFns } from "./dash-gh.vue?vue&type=template&id=6471ffd2&"
import script from "./dash-gh.vue?vue&type=script&lang=js&"
export * from "./dash-gh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports